export const mineTableColumns = [
  { label: 'Título', value: 'title' },
  { label: 'Tipo', value: 'result_type', className: 'w-0' },
  { label: 'Data e hora', value: 'created_at', className: 'w-0' },
  { label: '', value: 'action', className: 'w-0' },
]
